(() => {
  'use strict';
  if (window.hansNovemberStore) return;
  const source = document.getElementById('hans-commerce-config');
  if (!source) return;
  let config;
  try { config = JSON.parse(source.textContent); } catch { return; }
  const variants = config.variants || {};
  const keys = Object.keys(variants);
  if (!keys.length) return;
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const text = (key, fallback) => config.strings?.[key] || fallback;
  const title = value => value ? value[0].toUpperCase() + value.slice(1) : '';
  const rootUrl = (config.rootUrl || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const endpoint = path => rootUrl + path;
  const productUrl = new URL(config.productUrl || endpoint('products/legacy-lenses'), location.origin);
  const isProductPage = location.pathname.replace(/\/$/, '') === productUrl.pathname.replace(/\/$/, '');
  const colorForId = id => keys.find(key => String(variants[key].id) === String(id));
  const storedColor = () => { try { return sessionStorage.getItem('hansProposalColor'); } catch { return null; } };
  function initialColor() {
    const explicit = colorForId(new URL(location.href).searchParams.get('variant'));
    const stored = storedColor();
    return explicit || (isProductPage && colorForId(config.initialVariant)) || (variants[stored] && stored) || 'black' in variants && 'black' || keys[0];
  }
  let color = initialColor();
  let view = 0;
  let cart = null;
  let pending = false;
  let cartRevision = 0;
  let opener = null;
  const dialog = q('#bag');
  const zoomDialog = q('#zoom');
  const money = (amount, currency = cart?.currency || config.currency || 'USD') => {
    try { return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(Number(amount) / 100); }
    catch { return (Number(amount) / 100).toFixed(2) + ' ' + currency; }
  };
  function make(tag, className, content) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (content !== undefined) element.textContent = content;
    return element;
  }
  function status(message, error = false) {
    let element = q('[data-commerce-status]');
    if (!element) {
      element = make('p', 'fine');
      element.dataset.commerceStatus = '';
      element.setAttribute('role', 'status');
      element.setAttribute('aria-live', 'polite');
      (q('.purchase') || q('.d-optics__purchase') || document.body).append(element);
    }
    element.textContent = message;
    element.dataset.error = String(error);
    let bagStatus = q('[data-bag-status]', dialog || document);
    if (!bagStatus && dialog) {
      bagStatus = make('p', 'fine');
      bagStatus.dataset.bagStatus = '';
      bagStatus.setAttribute('role', 'status');
      dialog.querySelector('header')?.after(bagStatus);
    }
    if (bagStatus) bagStatus.textContent = message;
  }
  function showDialog(element, trigger) {
    if (!element) return;
    if (trigger instanceof HTMLElement) opener = trigger;
    if (!element.open) element.showModal();
  }
  qa('dialog').forEach(element => {
    element.addEventListener('close', () => { opener?.focus({ preventScroll: true }); opener = null; });
    element.addEventListener('click', event => {
      if (event.target !== element) return;
      const bounds = element.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) element.close();
    });
  });
  function galleryItems() { return variants[color].gallery || []; }
  function updateGallery() {
    const image = q('#gallery-image');
    if (!image) return;
    const items = galleryItems();
    if (!items.length) return;
    view = Math.min(view, items.length - 1);
    image.src = items[view].src;
    image.alt = items[view].alt || title(color) + ' Legacy Lenses';
    const thumbnails = q('.thumbnails');
    if (thumbnails) {
      const focusedView = thumbnails.contains(document.activeElement) ? document.activeElement.dataset.view : null;
      thumbnails.replaceChildren(...items.map((item, index) => {
        const button = make('button');
        button.type = 'button';
        button.dataset.view = String(index);
        button.setAttribute('aria-label', item.alt || `${text('image', 'Image')} ${index + 1}`);
        button.setAttribute('aria-pressed', String(index === view));
        const thumb = make('img');
        thumb.src = item.thumbnail || item.src;
        thumb.alt = '';
        thumb.width = 94;
        thumb.height = 94;
        thumb.loading = 'lazy';
        button.append(thumb);
        return button;
      }));
      if (focusedView !== null) q(`[data-view="${focusedView}"]`, thumbnails)?.focus({ preventScroll: true });
    }
    if (zoomDialog?.open) updateZoom();
  }
  function updateZoom() {
    const item = galleryItems()[view];
    if (!item || !zoomDialog) return;
    const image = q('img', zoomDialog);
    if (image) { image.src = item.src; image.alt = item.alt || title(color) + ' Legacy Lenses'; }
    const count = q('[data-zoom-count]');
    if (count) count.textContent = `${view + 1} / ${galleryItems().length}`;
  }
  function syncButtons() {
    const variant = variants[color];
    qa('[data-add], .d-optics__add').forEach(button => {
      button.disabled = pending || !variant.available;
      button.setAttribute('aria-busy', String(pending));
      button.textContent = pending ? text('adding', 'Updating…') : variant.available ? text('add', 'Add to bag') : text('sold_out', 'Sold out');
    });
    qa('[data-bag-change], [data-bag-remove]').forEach(button => { button.disabled = pending; });
    qa('[data-checkout], [data-preview-checkout]').forEach(button => {
      const disabled = pending || !cart?.item_count;
      button.setAttribute('aria-disabled', String(disabled));
      if ('disabled' in button) button.disabled = disabled;
    });
  }
  function syncColor(writeUrl = false) {
    const variant = variants[color];
    try { sessionStorage.setItem('hansProposalColor', color); } catch {}
    qa('button[data-choice], button[data-color]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.choice || button.dataset.color) === color)));
    const fill = (selector, value) => qa(selector).forEach(element => { element.textContent = value; });
    fill('[data-color-name]', title(color));
    fill('[data-pair-name], .d-optics__name', variant.name);
    fill('[data-selected-lens], [data-final-color]', `${title(color)} · ${variant.name}`);
    fill('.d-optics__finish', `${variant.mirror} ${text('mirror', 'mirror')}`);
    fill('[data-lens-summary]', `${variant.mirror} ${text('mirror', 'mirror')} · ${variant.tint} ${text('tint', 'tint')} · ${text('category', 'Category')} ${variant.category}`);
    fill('[data-vlt]', variant.vltText || (variant.vlt ? `${text('category', 'Category')} ${variant.category} · ${variant.vlt}% VLT` : `${text('category', 'Category')} ${variant.category}`));
    fill('[data-lens-detail]', variant.detail || `${title(color)} · ${variant.mirror} ${text('mirror', 'mirror')} · ${variant.tint} ${text('tint', 'tint')} · ${text('category', 'Category')} ${variant.category}`);
    fill('[data-price], .d-optics__price', variant.formattedPrice || money(variant.price, config.currency));
    fill('[data-studio-caption]', `${title(color)} · ${variant.mirror} ${text('mirror', 'mirror')}`);
    qa('[data-variant-id]').forEach(input => { input.value = String(variant.id); });
    const setImage = (selector, src, alt) => {
      if (!src) return;
      qa(selector).forEach(image => { if (image.getAttribute('src') !== src) image.src = src; if (alt) image.alt = alt; });
    };
    setImage('[data-wear-photo]', variant.face, `${title(color)} Legacy Lenses worn by Alex Ferreira`);
    setImage('[data-profile="on"]', variant.on, `${title(color)} Legacy Lenses, ${text('shields_on', 'shields on')}`);
    setImage('[data-profile="off"]', variant.off, `${title(color)} Legacy Lenses, ${text('shields_off', 'shields off')}`);
    setImage('[data-last-pair]', variant.hero, `${title(color)} Legacy Lenses`);
    setImage('[data-studio-photo]', variant.studio, `${title(color)} Legacy Lenses, ${variant.mirror.toLowerCase()} ${text('mirror', 'mirror')}`);
    qa('a[data-details], a[data-product-link]').forEach(link => {
      const url = new URL(link.getAttribute('href') || productUrl.href, location.origin);
      url.searchParams.set('variant', String(variant.id));
      link.href = url.pathname + url.search + url.hash;
    });
    if (writeUrl && isProductPage) {
      const url = new URL(location.href);
      url.searchParams.set('variant', String(variant.id));
      history.replaceState(history.state, '', url);
    }
    updateGallery();
    syncButtons();
  }
  function announceColor(next, writeUrl = true) {
    if (!variants[next]) return;
    color = next;
    syncColor(writeUrl);
    document.dispatchEvent(new CustomEvent('hans:color', { detail: { color, source: 'commerce' } }));
  }
  async function request(path, payload) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(endpoint(path), {
        method: payload ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
        ...(payload ? { body: JSON.stringify(payload) } : {}),
        signal: controller.signal
      });
      let result;
      try { result = await response.json(); } catch { throw new Error(text('cart_error', 'We couldn’t confirm your bag. Please try opening it again.')); }
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : text('update_error', 'We couldn’t update your bag. Please try again.'));
      return result;
    } finally { clearTimeout(timer); }
  }
  function renderCart(nextCart, focus) {
    cart = nextCart;
    const mixedShipping = q('[data-mixed-shipping]');
    if (mixedShipping) {
      const lines = cart.items || [];
      mixedShipping.hidden = !(lines.some(line => line.handle === 'legacy-lenses') &&
        lines.some(line => ['ODMPOD', 'Tapstitch'].includes(line.vendor)));
    }
    qa('[data-bag-count]').forEach(element => { element.textContent = String(cart.item_count || 0); });
    qa('[data-bag-total]').forEach(element => { element.textContent = money(cart.total_price, cart.currency); });
    const items = q('[data-bag-items]');
    if (items) {
      const content = document.createDocumentFragment();
      if (!cart.items?.length) content.append(make('p', '', text('empty', 'Your bag is empty.')));
      for (const item of cart.items || []) {
        const row = make('div', 'bag-item');
        row.dataset.lineKey = item.key;
        const image = make('img');
        const local = variants[colorForId(item.variant_id)];
        const imageUrl = local?.hero || item.featured_image?.url || item.image;
        if (imageUrl) image.src = imageUrl;
        image.alt = item.featured_image?.alt || item.product_title || item.title;
        image.width = 100;
        image.height = 100;
        image.loading = 'lazy';
        const body = make('div');
        const link = make('a', '', item.product_title || item.title);
        const destination = new URL(item.url || endpoint('cart'), location.origin);
        link.href = destination.origin === location.origin ? destination.pathname + destination.search : endpoint('cart');
        const heading = make('strong');
        heading.append(link);
        body.append(heading);
        if (local) body.append(make('p', '', `${title(colorForId(item.variant_id))} · ${local.name}`));
        else if (item.variant_title && item.variant_title !== 'Default Title') body.append(make('p', '', item.variant_title));
        for (const [key, value] of Object.entries(item.properties || {})) {
          if (!key.startsWith('_') && value) body.append(make('p', 'fine', `${key}: ${value}`));
        }
        if (item.selling_plan_allocation?.selling_plan?.name) body.append(make('p', 'fine', item.selling_plan_allocation.selling_plan.name));
        body.append(make('p', '', money(item.final_line_price ?? item.line_price, cart.currency)));
        for (const allocation of item.line_level_discount_allocations || []) {
          body.append(make('p', 'fine', allocation.discount_application?.title || text('discount', 'Discount applied')));
        }
        const quantity = make('div', 'bag-quantity');
        quantity.setAttribute('role', 'group');
        quantity.setAttribute('aria-label', `${text('quantity', 'Quantity')}: ${item.product_title || item.title}`);
        const decrease = make('button', '', '−');
        decrease.type = 'button';
        decrease.dataset.bagChange = item.key;
        decrease.dataset.quantity = String(Math.max(0, item.quantity - 1));
        decrease.dataset.action = 'decrease';
        decrease.setAttribute('aria-label', `${text('decrease', 'Decrease quantity of')} ${item.product_title || item.title}`);
        const number = make('span', '', String(item.quantity));
        number.setAttribute('aria-live', 'polite');
        const increase = make('button', '', '+');
        increase.type = 'button';
        increase.dataset.bagChange = item.key;
        increase.dataset.quantity = String(item.quantity + 1);
        increase.dataset.action = 'increase';
        increase.setAttribute('aria-label', `${text('increase', 'Increase quantity of')} ${item.product_title || item.title}`);
        const remove = make('button', '', text('remove', 'Remove'));
        remove.type = 'button';
        remove.dataset.bagRemove = item.key;
        remove.dataset.action = 'remove';
        remove.setAttribute('aria-label', `${text('remove', 'Remove')} ${item.product_title || item.title}`);
        quantity.append(decrease, number, increase, remove);
        body.append(quantity);
        row.append(image, body);
        content.append(row);
      }
      items.replaceChildren(content);
      if (focus && dialog?.open) {
        const next = qa('[data-line-key]', items).find(row => row.dataset.lineKey === focus.key);
        (next?.querySelector(`[data-action="${focus.action}"]`) || q('[data-close]', dialog))?.focus({ preventScroll: true });
      }
    }
    syncButtons();
    document.dispatchEvent(new CustomEvent('hans:cart', { detail: { cart } }));
  }
  async function refreshCart() {
    const revision = ++cartRevision;
    const result = await request('cart.js');
    if (revision === cartRevision) renderCart(result);
    return result;
  }
  async function openBag(trigger) {
    showDialog(dialog, trigger);
    try { await refreshCart(); status(''); } catch (error) { status(error.message, true); }
  }
  async function add(selected, trigger) {
    if (pending || !variants[selected]?.available) return;
    pending = true;
    ++cartRevision;
    status('');
    syncButtons();
    let added = false;
    try {
      await request('cart/add.js', { items: [{ id: Number(variants[selected].id), quantity: 1 }] });
      added = true;
      await refreshCart();
      showDialog(dialog, trigger);
      status(text('added', 'Added to your bag.'));
    } catch (error) {
      status(added || error.name === 'AbortError' ? text('uncertain', 'Your update could not be confirmed. Check your bag before trying again.') : error.message, true);
      try { await refreshCart(); } catch {}
    } finally { pending = false; syncButtons(); }
  }
  async function change(key, quantity, action) {
    if (pending) return;
    pending = true;
    ++cartRevision;
    status('');
    syncButtons();
    try {
      const result = await request('cart/change.js', { id: key, quantity });
      renderCart(result, { key, action });
      status(text('updated', 'Your bag is updated.'));
    } catch (error) {
      status(error.name === 'AbortError' ? text('uncertain', 'Your update could not be confirmed. Check your bag before trying again.') : error.message, true);
      try { await refreshCart(); } catch {}
    } finally { pending = false; syncButtons(); }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const addButton = q('[data-add]', form);
    if (!addButton) return;
    event.preventDefault();
    add(color, event.submitter || addButton);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('button, a');
    if (!button) return;
    if (button.dataset.choice && variants[button.dataset.choice] && button.tagName === 'BUTTON') {
      event.preventDefault();
      announceColor(button.dataset.choice);
    }
    if (button.hasAttribute('data-add') && !(button.type === 'submit' && button.form)) {
      event.preventDefault();
      add(color, button);
    }
    if (button.hasAttribute('data-open-bag')) { event.preventDefault(); openBag(button); }
    if (button.hasAttribute('data-bag-change')) { event.preventDefault(); change(button.dataset.bagChange, Number(button.dataset.quantity), button.dataset.action); }
    if (button.hasAttribute('data-bag-remove')) { event.preventDefault(); change(button.dataset.bagRemove, 0, 'remove'); }
    if (button.hasAttribute('data-checkout') || button.hasAttribute('data-preview-checkout')) {
      if (pending || !cart?.item_count) { event.preventDefault(); return; }
      if (button.hasAttribute('data-preview-checkout')) { event.preventDefault(); location.assign(endpoint('checkout')); }
    }
    if (button.hasAttribute('data-open-service')) { event.preventDefault(); showDialog(q('#service'), button); }
    if (button.hasAttribute('data-close')) button.closest('dialog')?.close();
    if (button.dataset.compare) {
      const comparison = q('[data-comparison]');
      if (comparison) comparison.dataset.comparison = button.dataset.compare;
      qa('[data-compare]').forEach(element => element.setAttribute('aria-pressed', String(element.dataset.compare === button.dataset.compare)));
    }
    if (button.dataset.view !== undefined) { view = Number(button.dataset.view); updateGallery(); }
    if (button.hasAttribute('data-enlarge')) { updateZoom(); showDialog(zoomDialog, button); }
    if (button.hasAttribute('data-zoom-next') || button.hasAttribute('data-zoom-prev')) {
      const count = galleryItems().length;
      if (count) { view = (view + (button.hasAttribute('data-zoom-next') ? 1 : count - 1)) % count; updateGallery(); }
    }
    if (button.dataset.openDetail) {
      const details = document.getElementById(button.dataset.openDetail);
      if (details) {
        event.preventDefault();
        details.open = true;
        details.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        q('summary', details)?.focus({ preventScroll: true });
      }
    }
  });
  document.addEventListener('keydown', event => {
    if (!zoomDialog?.open || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const count = galleryItems().length;
    if (count) { view = (view + (event.key === 'ArrowRight' ? 1 : count - 1)) % count; updateGallery(); }
  });
  document.addEventListener('hans:color', event => {
    if (event.detail?.source === 'commerce' || !variants[event.detail?.color]) return;
    color = event.detail.color;
    syncColor(true);
  });
  document.addEventListener('workshop:add', event => {
    const selected = colorForId(event.detail?.id ?? event.detail?.variant) || color;
    add(selected, event.detail?.button || q('.d-optics__add'));
  });
  window.addEventListener('popstate', () => announceColor(initialColor(), false));
  window.addEventListener('pageshow', event => { if (event.persisted) { announceColor(initialColor(), false); refreshCart().catch(() => {}); } });
  window.hansNovemberStore = { refreshCart, get color() { return color; } };
  syncColor();
  refreshCart().catch(() => {});
})();

